import { AppVariantConfig } from '@/types/app-config';

export const churchesVariant: AppVariantConfig = {
  id: 'churches',
  name: 'Churches',
  description: 'Church community features with groups, events, and donations',
  defaultRoute: 'directory',
  appModules: {
    directory: { enabled: true },
    groups: { 
      enabled: true, 
      requiresFeature: 'groups.blog' 
    },
    portal: { 
      enabled: true, 
      requiresFeature: 'portal',
      subModules: {
        events: { enabled: true, requiresFeature: 'events' },
        mail: { enabled: true, requiresFeature: 'mail' },
        addressBook: { enabled: true, requiresFeature: 'address_book' }
      }
    },
    payments: { 
      enabled: true, 
      requiresFeature: 'payments.donations',
      checkIfLive: true
    }
  },
  adminModules: {
    users: { enabled: true },
    groups: { enabled: true },
    events: { enabled: true },
    mail: { enabled: true },
    address_book: { enabled: true },
    payments: { enabled: true },
    settings: { enabled: true },
    design: { enabled: true },
    onboarding: { enabled: true }
  }
}; 